import Button from "@/components/base/Button";
import { clinicInfo } from "@/mocks/site";

interface CtaBannerProps {
  title?: string;
  text?: string;
}

export default function CtaBanner({
  title = "Ready to take the next step?",
  text = "Request an appointment with our orthopaedic and spine specialist, or call the clinic directly to speak with our team.",
}: CtaBannerProps) {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-primary-950 px-6 py-10 md:px-12 md:py-14">
          <div
            className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent-500/20 blur-3xl"
            aria-hidden="true"
          ></div>
          <div className="relative flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl font-semibold leading-tight text-background-50 md:text-3xl">
                {title}
              </h2>
              <p className="mt-3 font-body text-sm leading-relaxed text-background-200 md:text-base">{text}</p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Button to="/appointment" size="lg" icon="ri-calendar-check-line">
                Book an Appointment
              </Button>
              <Button href={clinicInfo.phoneHref} variant="light" size="lg" icon="ri-phone-fill">
                {clinicInfo.phoneDisplay}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}